import * as React from 'react';
import { observer } from 'mobx-react';

import { appStore } from '@app/Stores/AppStore';
import { DateTimeService } from '@app/Services/DateTimeService';
import ScenePlaceholder from '@app/Components/ScenePlaceholder';

@observer
export class NotFound extends React.Component<{}, {}> {
    public render() {
        const name = appStore.currentUserName;

        return (
            <ScenePlaceholder mainClass="page-not-found">
                <h1>404</h1>
                <h2>Page not found</h2>
                <p>
                    {name ? `Hi, ${name}!` : 'Hi!'} <br /> Sorry, but the page you are looking for was either not found or does not exist.
                </p>
                <p className="tal">
                    <small>
                        <strong>Path:</strong> {window.location.pathname}
                    </small>
                </p>
                <p className="tal">
                    <small>
                        <strong>Timestamp:</strong> {DateTimeService.format(DateTimeService.now(), 'YYYY-MM-DD HH:mm:ss')}
                    </small>
                </p>
            </ScenePlaceholder>
        );
    }
}
